import { View } from "./View";

export const NoDefaultAccountExists = () => {
  return <View />;
};
